import { Injectable } from "@angular/core";
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpXsrfTokenExtractor } from "@angular/common/http";
import { Observable } from "rxjs";
import { ConfigurationService } from "../services/configuration.service";

@Injectable({ providedIn: 'root' })
export class HttpXsrfInterceptor implements HttpInterceptor {
  constructor(
    private tokenService: HttpXsrfTokenExtractor,
    private configurationService: ConfigurationService) {
  }

  public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const lcUrl = req.url.toLowerCase();
    const config = this.configurationService.getConfiguration();
    const baseUrl = config ? config.baseUrl : null;

    if (req.method !== 'GET' && req.method !== 'HEAD' && baseUrl && baseUrl.length > 0 && lcUrl.startsWith(baseUrl)) {
      const token = this.tokenService.getToken();

      if (token !== null && !req.headers.has('X-XSRF-TOKEN')) {
        req = req.clone({ headers: req.headers.set('X-XSRF-TOKEN', token) });
      }
    }

    return next.handle(req);
  }
}
